// extracted by mini-css-extract-plugin
export default {"shiftButton":"CommonStyles_shiftButton__nWMot"};